import {
  CHANNEL_TYPE_PREVIEW,
  CHANNEL_TYPE_NEW,
  CHANNEL_TYPE_UPDATE,
  CHANNEL_TYPE_REMOVE,
  CHANNEL_TYPE_PROCESS_SUCCESS,
  CHANNEL_TYPE_DATASOURCE_SUCCESS,
  CHANNEL_TYPE_SEARCH,
  CHANNEL_TYPE_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANNEL_TYPE_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case CHANNEL_TYPE_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case CHANNEL_TYPE_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case CHANNEL_TYPE_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case CHANNEL_TYPE_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case CHANNEL_TYPE_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case CHANNEL_TYPE_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case CHANNEL_TYPE_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}